import SecureCodingImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/secure_coding.svg";
import SecureConceptsImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/security_concepts.svg";
import SecureDevelopmentImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/secure_development.svg";
import AiLlmImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/ai_llm.svg";

export const SELF_SELECT = "selfSelect";
export const ASSIGN_SPECIFIC = "assignSpecific";
export const SECURE_CODING = "secure-coding";

export const USED_ASSESSMENT_NAME_ERROR = "This assessment name is already taken";

export const notificationOptions = ["None", "Weekly", "Monthly", "Quarterly"] as const;
export type NotificationOption = (typeof notificationOptions)[number];

export const reminderTextMap: Record<NotificationOption, string> = {
  None: "No reminder emails will be sent.",
  Weekly: "Learners will receive reminder emails every week until the assessment is complete.",
  Monthly: "Learners will receive reminder emails every month until the assessment is complete.",
  Quarterly:
    "Learners will receive reminder emails every quarter until the assessment is complete.",
};

export const CATEGORY_ORDER = [
  "secure-coding",
  "core-security-concepts",
  "secure-development",
  "ai-llm",
] as const;

export const CATEGORY_VARIANTS = ["mauve", "blue", "teal", "indigo"] as const;

export const categorySubTitles: Record<string, string> = {
  "secure-coding": "Hands-on coding questions",
  "core-security-concepts": "Multiple choice questions",
  "secure-development": "Multiple choice questions",
  "ai-llm": "Artificial Intelligence and Large Language Models (AI/LLM) Multiple choice questions",
};

export const KA_CARD_IMAGE_MAP: Record<string, string> = {
  "secure-coding": SecureCodingImageUrl,
  "core-security-concepts": SecureConceptsImageUrl,
  "secure-development": SecureDevelopmentImageUrl,
  "ai-llm": AiLlmImageUrl,
};
